type CategoryFirstShop = {
  brand?: { settings?: { categoryFirstBookingEnabled?: boolean } };
};

export type CategoryEntry = 'professional_first' | 'service_first';
export type CategoryFlagState = 'on' | 'off';

/** A named professional (or a professional's own link) is professional-first. */
export function getCategoryEntry(barberIdOrRoute?: string): CategoryEntry {
  return barberIdOrRoute === undefined ? 'service_first' : 'professional_first';
}

/** The category-first rule: the umbrella flag AND the brand's opt-in setting. */
export function isCategoryFirstEnabledFor(
  isFlagEnabled: boolean,
  shop: CategoryFirstShop,
): boolean {
  return (
    isFlagEnabled && shop.brand?.settings?.categoryFirstBookingEnabled === true
  );
}

export function toCategoryFlagState(isEnabled: boolean): CategoryFlagState {
  return isEnabled ? 'on' : 'off';
}

export function getCategoryFlagState(
  isFlagEnabled: boolean,
  shop: CategoryFirstShop,
): CategoryFlagState {
  return toCategoryFlagState(isCategoryFirstEnabledFor(isFlagEnabled, shop));
}
